require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./research-triple-negative-breast-cancer-new-hope-for-an-existing-drug.json") })
        }
      }, "path---research-triple-negative-breast-cancer-new-hope-for-an-existing-drug");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---research-triple-negative-breast-cancer-new-hope-for-an-existing-drug!./.cache/json/research-triple-negative-breast-cancer-new-hope-for-an-existing-drug.json
// module id = 492
// module chunks = 231608221292675